import { useTranslation } from "react-i18next";
import { FormSection } from "../../../components/FormSection";
import { getEffectiveBookkeepingMapping } from "@KassaroAB/shared/utils/bookkeepingDefaultAccounts";
import type { PaymentMethodOther } from "@KassaroAB/shared/types/paymentMethods/paymentMethod";
import { FieldGroupPaymentMethodFields } from "../paymentMethodFieldGroup";
import { usePaymentMethodForm } from "../paymentMethodFormHook";
import {
  PaymentMethodFormContainer,
  type PaymentMethodFormProps,
} from "./PaymentMethodFormContainer";
import { basePaymentMethodValues } from "./basePaymentMethodValues";
import { Fields, ToggleField } from "./paymentMethodFields";

export const OtherForm = ({
  formId,
  store,
  paymentMethod,
  savedTick,
  onSubmit,
  onDirtyChange,
}: PaymentMethodFormProps<Omit<PaymentMethodOther, "id">>) => {
  const { t } = useTranslation();
  const mergedAccounts = getEffectiveBookkeepingMapping(
    store.country,
    store.bookkeepingDefaultAccounts,
  );
  const form = usePaymentMethodForm({
    defaultValues: {
      ...basePaymentMethodValues(paymentMethod),
      openCashDrawer: paymentMethod.openCashDrawer ?? false,
      askForAmount: paymentMethod.askForAmount ?? false,
    },
    onSubmit: ({ value }) => onSubmit(value),
  });

  return (
    <PaymentMethodFormContainer
      formId={formId}
      form={form}
      savedTick={savedTick}
      onDirtyChange={onDirtyChange}
    >
      <FieldGroupPaymentMethodFields
        form={form}
        fields={{
          name: "name",
          type: "type",
          bookkeepingAccountId: "bookkeepingAccountId",
          color: "color",
        }}
        defaultAccountNumber={mergedAccounts.businessAccount}
        t={t}
      />
      <FormSection title={t("paymentMethodForm.additionalSettings")}>
        <Fields>
          <form.Field name="openCashDrawer">
            {(field) => (
              <ToggleField
                label={t("paymentMethodForm.openCashDrawer")}
                value={field.state.value}
                onChange={field.handleChange}
                onBlur={field.handleBlur}
              />
            )}
          </form.Field>
          <form.Field name="askForAmount">
            {(field) => (
              <ToggleField
                label={t("paymentMethodForm.askForAmount")}
                value={field.state.value}
                onChange={field.handleChange}
                onBlur={field.handleBlur}
              />
            )}
          </form.Field>
        </Fields>
      </FormSection>
    </PaymentMethodFormContainer>
  );
};
